import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';
import { ButtonComponent } from '../button/button.component';
import { BadgeComponent } from '../../atoms/badge/badge.component';
import { Sizes, Colors } from '../../../shared/enums/shared.enums';
import { ModalComponent } from '../modal/modal.component';
import { ModalFunctionType } from '../../../shared/enums/modal-function-type.enums';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import BadgeType from '../../../shared/enums/badge-type.enums';
import { ModalType } from '../../../shared/enums/modal-type.enums';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ImageComponent } from '../../atoms/image/image.component';
import { ActivatedRoute } from '@angular/router';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-modal-function',
  standalone: true,
  templateUrl: './modal-function.component.html',
  styleUrl: './modal-function.component.scss',
  imports: [
    CommonModule,
    IconComponent,
    ButtonComponent,
    BadgeComponent,
    ImageComponent,
    CapitalizePipe,
  ],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ModalFunctionComponent implements OnInit {
  IconTooltip = 'tooltip';
  IconList = 'list';
  IconPlay = 'circle-play';
  IconExpand = 'expand';
  buttonType = ButtonType;
  @Input() size: Sizes = Sizes.MEDIUM;
  @Input() color: Colors = Colors.NEUTRAL_MEDIUM;
  @Input() type: ModalFunctionType = ModalFunctionType.TOOLTIP;
  @Input() label: string = 'Mehr erfahren';
  @Input() imageSrc: string | undefined = '';
  @Input() imageAlt: string | undefined = '';
  @Input() imageTitle: string | undefined = '';
  @Input() videoSrc!: SafeResourceUrl;
  @Input() videoId!: string;
  @Input() videoTitle: string = '';
  @Input() thumbnailSrc!: string;
  @Input() showIcon: boolean = true;
  @Input() showBadge?: boolean = false;
  @Input() badgeLabel?: string = 'INKLUSIVE eDATA';
  @Input() modalFunctionLabel: string = 'Modal List Option';
  @Input() modalFunctionHeadline: string | undefined = '';
  @Input() secondaryIcon: string | undefined;
  @Input() playButtonSize: Sizes = Sizes.MEDIUM;
  @Input() videoSizes: Sizes = Sizes.MEDIUM;
  @Input() imageObjectPosition: string = 'center';
  @ViewChild(ModalComponent) modalComponent!: ModalComponent;

  public showModal = false;
  public placeholderSrc = 'assets/images/placeholder_magenta.jpg';
  Sizes = Sizes;
  BadgeType = BadgeType;
  ModalType = ModalType;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.checkVideoIdFromUrl();
  }

  checkVideoIdFromUrl(): void {
    const fragment = this.route.snapshot.fragment;

    if (fragment) {
      if (fragment === this.videoId) {
        this.openModal();
      } else {
        console.warn('No matching videoId in fragment:', fragment);
      }
    }
  }

  openModal(): void {
    if (typeof window !== 'undefined') {
      const event = new CustomEvent('openVideoModal', {
        detail: {
          videoSrc: this.videoSrc,
          videoId: this.videoId,
          thumbnailSrc: this.thumbnailSrc,
        },
      });
      window.dispatchEvent(event);
      this.showModal = true;
    }
  }

  handleCloseModal(): void {
    this.showModal = false;
  }
}
